/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { Component,  OnInit,HostListener } from '@angular/core';
import { NbTokenLocalStorage, NbAuthToken, NbPasswordAuthStrategy, NbAuthService, NbAuthResult } from '@nebular/auth';
import { AnalyticsService } from './@core/utils/analytics.service';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@microsoft/signalr';
import { SessionIdleService } from './@auth/session-idle.service';
import { SharedService } from './@core/interfaces/masters/SharedService';
import { Title } from '@angular/platform-browser';
import { FaviconService } from './favicon-service';
import { VideoCallService } from './@theme/components/common/service/VideoCall.service';

@Component({
  selector: 'ngx-app',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit   {

  constructor(private analytics: AnalyticsService,private sharedService:SharedService,  private titleService: Title,
    private faviconService: FaviconService,
    private videoCallService:VideoCallService,
              private authStrategy: NbPasswordAuthStrategy,
              private tokenStorage: NbTokenLocalStorage,
              private sessionIdle: SessionIdleService, public router:Router,protected service: NbAuthService) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.validateSessionTimeout();
    // Idle sign-out (shared by all tabs, with a warning first). Started after validateSessionTimeout():
    // the shared idle clock keeps its own keys in localStorage, which would defeat that empty-storage check.
    this.sessionIdle.start();

    const brandCode = environment.brandCode;
    if (brandCode.key === 'shukhee') {
      this.titleService.setTitle(brandCode.value); 
      this.faviconService.updateFavicon('assets/faviconshukhee.ico');
    } else {
      this.titleService.setTitle('Ezovion HMS');
      this.faviconService.updateFavicon('assets/favicon.ico');
    }
  }


  validateSessionTimeout(){
if(localStorage.length==0){
  this.router.navigateByUrl("/auth/login");
  localStorage.clear();
}
  }

  // SECURITY: removed initTestUserToken() (Akveo ngx-admin starter-template leftover that
  // seeded a hardcoded demo JWT into NbTokenLocalStorage "for a better demo experience").
  // It was never called from ngOnInit() or anywhere else - dead code - but the hardcoded
  // token it referenced (environment.testUser.token) still got compiled into the production
  // bundle, which is what got flagged. See environment.ts / environment.prod.ts.
}
